import React from 'react';
import classnames from 'classnames';
import { branch, compose, defaultProps, renderNothing } from 'recompose';
import styles from '../../styles/components/bar-chart.module.scss';

const Container = compose(
  defaultProps({ height: '100%' }),
  branch(({ height }) => parseFloat(height) <= 0, renderNothing)
);

const Item = React.memo(({ renderAs: Component = 'li', value, color, height, className }) => (
  <Component data-value={value} className={classnames(styles.item, className)} style={{ color, height }} />
));

const Stack = React.memo(({ height, className, children }) => (
  <ul className={classnames(styles.stack, className)} style={{ height }}>
    {children}
  </ul>
));

export const Bar = Container(Item);
export const StackedBar = Container(Stack);
